
import {
    Row, Col, Input,
    Button,
    Divider, message
} from '../../ui/ot'
import { useEffect, useState, useRef } from "react"
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { Card, CardContent, } from "../../ui/card"
import { Avatar, AvatarFallback } from "../../ui/avatar"
import { StarIcon, User, Loader2 } from "lucide-react"

const ReaderReview = ({
    keyPrefix = 'library.reader_reviews',
    bibValue = null,
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [newReview, setNewReview] = useState("")
    const [rating, setRating] = useState(0)
    const [loading, setLoading] = useState(true)
    const [borrowernumber, set_borrowernumber] = useState(0);

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
            }

        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
            }
        }
        if (axiosMode !== "get") {
            reviewFrontendController.getData({
                biblionumber: bibValue?.bib_biblionumber
            }).finally(() => {
                setLoading(false)
            })
        }
        setLoading(false)
    };
    const handleReviewSubmit = () => {
        if (newReview.trim() === "") {
            return
        }

        if (rating === 0) {
            return
        }
        reviewController.postData([
            {
                "biblionumber": bibValue?.bib_biblionumber,
                "review_content": newReview,
                "star": rating,
            }
        ])
        setNewReview("")
        setRating(0)
    }
    const reviewFrontendController = useCRUDController({
        apiRoute: "/library/api/frontend/review",
        onFinish: onFinish,
        onBefore: ({ axiosMode, status, values }) => {
            setLoading(true)
        }
    })
    const reviewController = useCRUDController({
        apiRoute: "/library/review",
        onFinish: onFinish,
        onBefore: ({ axiosMode, status, values }) => {
            setLoading(true)
        }
    })
    const BorrowerSelfController = useCRUDController({
        apiRoute: "/library/koha/borrower/self",
    })
    useEffect(() => {
        BorrowerSelfController.getData({})
            .then((response) => {
                let data = response?.data || []
                let data_first = data?.find((ele) => true)
                set_borrowernumber(data_first?.borrowernumber)
            })
            reviewFrontendController.getData({
            biblionumber: bibValue?.bib_biblionumber
        }).finally(() => {
            setLoading(false)
        })
    }, [])
    return (<Row >
        <Col span={24}  >
            <div className="space-y-4">
                <h3 className="text-lg font-semibold text-[#2f7c9d] flex items-center">
                    <StarIcon className="mr-2 h-5 w-5 fill-orange-400 stroke-orange-500" />
                    {t('reader_reviews')}
                </h3>
                {loading ? <div className="flex flex-col items-center justify-center min-h-[50vh] w-full">
                    <Loader2 className="h-8 w-8 animate-spin text-primary" />
                    <p className="mt-4 text-sm text-muted-foreground"></p>
                </div> : reviewFrontendController?.ResponseData?.map((review) => (
                    <Card key={review.id} className="border border-[#d5e6ed] hover:shadow-md transition-shadow">
                        <CardContent className="pt-6">
                            <div className="flex items-start gap-4">
                                <Avatar className="border-2 border-[#d5e6ed]">
                                    <AvatarFallback className="bg-[#2f7c9d] text-white"><User /></AvatarFallback>
                                </Avatar>
                                <div className="space-y-2 w-full">
                                    <div className="flex justify-between items-center">
                                        <div className="font-medium text-[#2f7c9d]">{review?.create_user_name}</div>
                                        <div className="text-sm text-[#5a9bb6]">{review?.review_date}</div>
                                    </div>
                                    <div className="flex">
                                        {[...Array(5)].map((_, i) => (
                                            <StarIcon
                                                key={i}
                                                className={`w-4 h-4 ${i < review?.star ? "fill-orange-400 stroke-orange-500" : "fill-gray-200 stroke-gray-300"}`}
                                            />
                                        ))}
                                    </div>
                                    <p className="text-sm">{review?.review_content}</p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
            <Divider />
            {/* 登入才可以評論 */}
            {!!borrowernumber && <div className="space-y-4 bg-[#eaf2f6] p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-[#2f7c9d]">{t('write_review')}</h3>
                <div className="flex gap-1">
                    {[...Array(5)]?.map((_, i) => (
                        <StarIcon
                            key={i}
                            className={`w-8 h-8 cursor-pointer transition-all ${i < rating ? "fill-orange-400 stroke-orange-500 scale-110" : "fill-gray-200 stroke-gray-300"}`}
                            onClick={() => setRating(i + 1)}
                        />
                    ))}
                </div>
                <Input.TextArea
                    placeholder="分享您對這本書的看法..."
                    className="min-h-[100px] border-[#d5e6ed] focus:border-[#2f7c9d] focus:ring-[#2f7c9d]"
                    value={newReview}
                    onChange={(e) => setNewReview(e.target.value)}
                />
                <Button onClick={handleReviewSubmit} className="bg-orange-500 hover:bg-orange-600 text-white">
                    {t('submit_review')}
                </Button>
            </div>}
        </Col>
    </Row>)
}


export default ReaderReview